<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>تقرير باخر الصيانات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                          هنا يتم عرض آخر عمليات صيانه لكل عميل

                              <div class='pull-left' style='padding=0px'>
                                <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                  <b> طباعة </b>
                                </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                                  <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                  </ul>
                                </div>
                                <div class="col-lg-10 col-md-9 col-sm-12">
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>الفرع</label>
                                    <select  @change='FillItineraries()' class="form-control"  v-model="brancheID">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>المنطقة:</label>
                                    <select class="form-control" style="padding: 0px" v-model="region_id">
                                      <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.region_name }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <div class="form-group">
                                      <label>المديونية</label>
                                      <select class="form-control"  v-model="balance">
                                        <option value='0'></option>
                                        <option value='1'>مدين</option>
                                        <option value='2'>غير مدين</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <div class="form-group">
                                      <label>الترتيب</label>
                                      <select class="form-control"  v-model="sorte">
                                        <option value='rec_id'></option>
                                        <option value='id'>الكود</option>
                                        <option value='branche_id'>الفرع</option>
                                        <option value='line_id'>الخط</option>
                                        <option value='region_id'>المنطقة</option>
                                        <option value='village'>القرية</option>
                                        <option value='rec_id'>السجل</option>
                                        <option value='name'>الاسم</option>
                                        <option value='evaluation'>التقييم</option>
                                        <option value='balance'>الرصيد</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>&nbsp;</label>
                                    <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                      <b> عرض </b>
                                    </button>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>&nbsp;</label>
                                    <button @click='printSelecter()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                      <b> تطبيق الاختيار </b>
                                    </button>
                                  </div>
                              </div>
                                <div class="col-lg-2 col-md-3 col-sm-12" style="padding: 0px">
                                  <!-- /.panel -->
                                  <div class="chat-panel panel panel-default" >
                                    <div class="panel-heading">
                                      الخطوط
                                    </div>
                                    <!-- /.panel-heading -->
                                    <div class="panel-body" style="padding: 5px">
                                      <div v-for="(item,index) in lines" v-bind:key="index" >
                                        <input @click="FillRegions($event)" :id="index" type="checkbox" :value="item.id" v-model="selectedLine">{{' ' + item.name }}
                                      </div>
                                    </div>
                                    <!-- /.panel-body -->
                                  </div>
                                </div>
                                    <div id="contentToPrint">
                                      <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                          <thead>
                                            <tr>
                                              <th style='padding:2px;text-align: center'>م</th>
                                              <th style='padding:2px;text-align: center'>الكود</th>
                                              <th style='padding:2px;text-align: center'>الاسم</th>
                                              <th style='padding:2px;text-align: center'>الخط</th>
                                              <th style='padding:2px;text-align: center'>المنطقة</th>
                                              <th style='padding:2px;text-align: center'>العنوان</th>
                                              <th style='padding:2px;text-align: center'>المحمول</th>
                                              <th style='padding:2px;text-align: center'>مديونية اقساط</th>
                                              <th style='padding:2px;text-align: center'>مديونية صيانة</th>
                                              <th style='padding:2px;text-align: center'>ملاحظات</th>
                                              <th style='padding:2px;text-align: center'>آخر اتصل</th>

                                              <th width="200" style='padding:2px;text-align: center'>الصيانة</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-show="isPrint === false || (isPrint === true && record.selected === true)" class='odd gradeX' v-for='(record,index) in record' :key='record.id'>

                                                 <td align='center'>{{index +1 }}
                                                   <input type="checkbox" :value="record.selected" v-model="record.selected">

                                                 </td>
                                                 <td align='center'>{{record.rec_id}}</td>
                                                 <td align='right'>{{record.name}} <br> [{{record.nickname}}] </td>
                                                 <td align='center'>{{record.line_name}}</td>
                                                 <td align='center'>{{record.region_name}}</td>
                                                 <td align='center'>{{record.address}}</td>
                                                 <td align='center'>{{record.mobile}}</td>
                                                 <td align='center'>{{record.maintenance_ind}}</td>
                                                 <td align='center'>{{record.indebtedness}}</td>
                                                 <td align='center'>{{record.notes}}</td>
                                                 <td align='center'>{{record.call_note}}</td>
                                                 <td width="200" align='right'>
                                                   <ul >
                                                     <li v-for="item in record.maintenance" :key="item.id">
                                                       {{ item.change_date }} - {{ item.item }}
                                                     </li>
                                                   </ul>
                                                 </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'InstallmentsArrears',
  data () {
    return {
      sorte: 'rec_id',
      balance: '',
      isPrint: false,
      emptyRec: [{id: 0, name: 0}],
      brancheID: 0,
      itinerarie: 0,
      branches: {},
      region_id: {},
      regions: '',
      record: {},
      lines: {},
      line: '',
      validationErrors: '',
      selectedLine: [],
      isLoadingData: false
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.FillItineraries()
  },
  methods: {
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
      if (i > -1) {
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    FillRegions (e) {
      this.$nextTick(() => {
        var id = (this.selectedLine[0])
        this.regions = ''
        this.region_id = ''
        if (id != null && id.length !== 0) {
          let r = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
          let i = this.branches[r].itineraries.findIndex(x => x.id === parseInt(id))
          if (i > -1) {
            this.regions = JSON.parse(JSON.stringify(this.branches[r].itineraries[i].regions))
            this.regions.unshift(this.emptyRec)
          }
        }
      })
    },
    printSelecter () {
      this.isPrint = true
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'last-maintenance', {
        token: localStorage.getItem('token'),
        branch_id: this.brancheID,
        from: this.from_date,
        to: this.to_date,
        region_id: this.region_id,
        sorte: this.sorte,
        balance: this.balance,
        selectedLine: this.selectedLine
      })
        .then(({ data }) => {
          this.record = data
          this.isLoadingData = false
          this.isPrint = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Reports/LastMaintenance.vue